import { render, staticRenderFns } from "./EEscolhaDisciplinaPlanoMensal.vue?vue&type=template&id=21878508"
import script from "./EEscolhaDisciplinaPlanoMensal.vue?vue&type=script&lang=js"
export * from "./EEscolhaDisciplinaPlanoMensal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports